const headers = {
  name: "Milestones",
  navigate: {
    path: [
      {
        name: "Milestones",
        path: "/app/about/milestones",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
